import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { BASE_KEY } from './backgroundKeys';
import { IBackgroundResponse } from './useQueryBackgrounds';

export interface ICreateBackgroundParams {
  url: string;
  fileName: string;
}

export const createBackground = async (
  params: ICreateBackgroundParams
): Promise<IBackgroundResponse> => {
  const response = await EXPRESS_API.post(`/backgrounds`, params);
  return response.data;
};

export const useCreateBackgroundMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(createBackground, {
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: BASE_KEY,
        exact: false,
      });
      onSuccess && onSuccess();
      successToast({
        title: `Background has been successfully created!`,
      });
    },
    onError: error =>
      showError(
        error || `An error occurred while trying to create the background!`
      ),
  });
};
